import ReactDOM from 'react-dom/client';

import './components/CSS/index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
